import { mainApi } from '../utils/api';

import { type BaseInput, type ByIdInput } from './models';

export type ShareModelToHostInput = ByIdInput & {
  data: {
    shared_model_name?: string;
    shared_model_description?: string;
  };
};

export type GetSharedModelsInput = BaseInput;

export type GetSharedModelsByFilterInput = ByIdInput;

export type GetSharedModelByIdInput = ByIdInput;

export type GetSharedModelOutputInput = ByIdInput;

export type GetSharedModelSharingInvitationsInput = ByIdInput;

export type ImportSharedModelInput = ByIdInput;

export type ShareModelInput = ByIdInput & {
  data: {
    separate_guests?: boolean;
    share_message?: string;
    shared_model_name?: string;
    shared_model_description?: string;
    filters: {
      aircrafts?: string[];
      airports?: string[];
    };
    guests: {
      email: string;
      role: string;
    }[];
  };
};

export type RevokeSharedModelInput = ByIdInput;

export type DeleteSharedModelInput = ByIdInput;

const importSharedModel = ({
  modelId,
  orgId,
  projectId,
}: ImportSharedModelInput) =>
  mainApi.post(
    `organizations/${orgId}/projects/${projectId}/shared_models/${modelId}/clone/`
  );

const getSharedModelSharingInvitations = ({
  modelId,
  orgId,
  projectId,
}: GetSharedModelSharingInvitationsInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/shared_models/${modelId}/sharing_invitations/`
  );

const getSharedModelOutput = ({
  modelId,
  orgId,
  projectId,
}: GetSharedModelOutputInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/shared_models/${modelId}/output/`
  );

const shareModelToHost = ({
  orgId,
  projectId,
  modelId,
  data,
}: ShareModelToHostInput) =>
  mainApi.post(
    `organizations/${orgId}/projects/${projectId}/models/${modelId}/share_to_host/`,
    data
  );

const shareModel = ({ orgId, data, projectId, modelId }: ShareModelInput) =>
  mainApi.post(
    `organizations/${orgId}/projects/${projectId}/models/${modelId}/share/`,
    data
  );

const getSharedModels = ({ orgId, projectId }: GetSharedModelsInput) =>
  mainApi.get(`organizations/${orgId}/projects/${projectId}/shared_models/`);

const getSharedModelsByFilter = ({
  orgId,
  projectId,
  modelId,
}: GetSharedModelsByFilterInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/shared_models/?from_model=${modelId}`
  );

const getSharedModelById = ({
  orgId,
  projectId,
  modelId,
}: GetSharedModelByIdInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/shared_models/${modelId}`
  );

const revokeSharedModel = ({
  orgId,
  projectId,
  modelId,
}: RevokeSharedModelInput) =>
  mainApi.post(
    `organizations/${orgId}/projects/${projectId}/shared_models/${modelId}/revoke/`
  );

const deleteSharedModelById = ({
  orgId,
  projectId,
  modelId,
}: DeleteSharedModelInput) =>
  mainApi.delete(
    `organizations/${orgId}/projects/${projectId}/shared_models/${modelId}/`
  );

export {
  getSharedModelById,
  getSharedModelOutput,
  getSharedModels,
  getSharedModelsByFilter,
  getSharedModelSharingInvitations,
  revokeSharedModel,
  importSharedModel,
  shareModel,
  shareModelToHost,
  deleteSharedModelById,
};
